export default "__VITE_ASSET__ByuFNhDo__"